import React from 'react';

import { DreRelatorioComp } from './components';

import { ListagemProvider } from 'context/ListagemContext';

export function DreRelatorio() {
    return (
        <ListagemProvider>
            <DreRelatorioComp />
        </ListagemProvider>
    );
}
